import Dexie from 'dexie';

import { CoSyncStrategy } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';
import { SyncOperationType } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/SyncOperationItem';
import { SyncTreeNode } from '@/workerProcessRenderer/scripts/CoSyncEngine/Tree/typings';
import { conflictResolveType } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/ConflictData';

export type SyncTreeDAONode = SyncTreeNode & { id?: number };

const coSyncTreeDB = new Map<number, Dexie>();

export function getCoSyncTreeDB(localSyncId: number) {
  let dexie!: Dexie;

  if (coSyncTreeDB.has(localSyncId)) {
    dexie = coSyncTreeDB.get(localSyncId)!;
  } else {
    dexie = new Dexie(`CoSyncTreeDB_${localSyncId}`);
    dexie.version(1).stores({
      syncTree: 'path',
    });
  }

  coSyncTreeDB.set(localSyncId, dexie);

  const deleteDB = async () => {
    await dexie.delete();
  };

  return {
    dexie,
    deleteDB,
    syncTree: dexie.table<SyncTreeDAONode, number>('syncTree'),
  };
}

export type CoSyncTreeDB = ReturnType<typeof getCoSyncTreeDB>;
